<template>
  <div class='reseller-subscribe-container'>
    <div class="qrcode-img-wrapper">
      <img src="../../assets/img/img_applet_jxs.jpg">
      <p>扫描二维码【国花瓷经销商】小程序</p>
      <p>待管理员审核通过后，即可通过账号密码登陆</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResellerSubscribe',
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.reseller-subscribe-container {
  width: 100%;
  height: 100%;
  background: #fff;
  .qrcode-img-wrapper {
    padding: 150px 0;
    text-align: center;
    img {
      width: 186px;
      height: 200px;
    }
    p {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #747474;
      letter-spacing: -0.35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/reseller/subscribe.vue